<template>
  <div id="app">
    <div
      id="main-navbar"
      class="navbar navbar-light navbar-expand-md fixed-top"
    >
      <div class="navbar-header navbar-dark bg-blue-700 d-none d-md-flex align-items-md-center">
        <div class="navbar-brand navbar-brand-md">
          <a href="#" class="d-inline-block">
            <!--Alice Logo Here-->
            <img src="../assets/images/alice_logo_light.png" alt />
          </a>
        </div>

        <div class="navbar-brand navbar-brand-xs">
          <a href="#" class="d-inline-block">
            <!--Alice Logo Here-->
            <img src="../assets/images/alice_logo_icon_light.png" alt />
            <!-- <img src="../assets/images/alice_logo_icon_light.png" alt /> -->
          </a>
        </div>
      </div>
      <!-- Mobile controls -->
      <div class="d-flex flex-1 d-md-none">
        <div class="navbar-brand mr-auto">
          <a href="#" class="d-inline-block">
            <!--Alice Logo Here-->
            <!-- <img src="../assets/images/alice_logo_light.png" alt="logo"/> -->
            <img src="../assets/images/alice_logo_dark.png" alt />
          </a>
        </div>

        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbar-mobile"
        >
          <i class="icon-tree5"></i>
        </button>

        <button class="navbar-toggler sidebar-mobile-main-toggle" type="button">
          <i class="icon-paragraph-justify3"></i>
        </button>
      </div>
      <!-- /mobile controls -->
      <div class="collapse navbar-collapse" id="navbar-mobile">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a
              href="#"
              class="navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block"
              onclick="window.dispatchEvent(new Event('resize'))"
            >
              <i class="icon-paragraph-justify3"></i>
            </a>
          </li>
          <li class="nav-item">
            <!-- a.navbar-nav-link font-weight-semibold>Bot name / Dashboard name -->
          </li>
        </ul>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item bulma-dropdown dropdown-user">
            <b-dropdown id="user-dropdown" aria-role="list" position="is-bottom-left">
              <div
                class="d-flex align-items-center no-user-select" slot="trigger"  role="button"
              >
                <i class="fa fa-user-circle mr-2"></i>
                {{username | capitalize}}&nbsp;
                <i class="fa fa-angle-down ml-2"></i>

              </div>
               <b-dropdown-item v-show="role !== 'superuser'"
                              aria-role="listitem"
                              class="collection-menu-item"
                              @click="toggleChangePassWordModal(true)">
                <i class="icon-pencil"></i> Change password
              </b-dropdown-item>
              <b-dropdown-item aria-role="listitem"
                               class="collection-menu-item"
                               @click="logout">
                <i class="icon-switch2"></i> Logout
              </b-dropdown-item>
            </b-dropdown>
          </li>
        </ul>
      </div>
    </div>
    <div class="page-content">
      <div
        id="main-sidebar"
        class="sidebar sidebar-dark bg-blue-800 sidebar-main sidebar-expand-md"
      >
        <div class="sidebar-mobile-toggler text-center">
          <a href="#" class="sidebar-mobile-main-toggle">
            <i class="icon-arrow-left8"></i>
          </a>
          Navigation
          <a href="#" class="sidebar-mobile-expand">
            <i class="icon-screen-full"></i>
            <i class="icon-screen-normal"></i>
          </a>
        </div>
        <div class="sidebar-content">
          <!-- Main navigation -->
          <div class="card card-sidebar-mobile">
            <ul class="nav nav-sidebar" data-nav-type="accordion">
              <!-- Main -->
              <li class="nav-item" v-show="hasPermission('home')">
                <router-link to="/" class="nav-link" exact>
                  <i class="mi-dashboard"></i>
                  <span>Dashboard</span>
                </router-link>
              </li>
              <!-- Conversation menu here -->
              <li class="nav-item" v-if="!menuConfig.understanding.isHide" v-show="hasPermission('understanding')">
                <router-link to="/understanding" class="nav-link" exact>
                  <i class="icon-reading"></i>
                  <span>Understanding</span>
                  <span
                    v-if="needResolveIssue"
                    class="badge bg-pink-300 align-self-center ml-auto"
                  >{{issueCount}}</span>
                </router-link>
              </li>
              <!-- /main -->
              <li class="nav-item nav-item-submenu" v-if="!menuConfig.knowledge.isHide">
                <a class="nav-link no-user-select">
                  <i class="icon-stack"></i>
                  <span>Knowledge</span>
                  <span class="text-pink-300 noti-icon" v-show="allModelTotalToBeTrainCount">
                    <i class="fas fa-circle"></i>
                  </span>
                </a>
                <ul class="nav nav-group-sub" data-submenu-title="Knowledge">
                  <!-- <li class="nav-item" v-show="hasPermission('train')">
                    <router-link to="/knowledge/train" class="nav-link" exact>
                      <span>Model Training</span>
                      <span
                        v-if="allModelTotalToBeTrainCount"
                        class="badge bg-pink-300 align-self-center ml-auto"
                      >{{allModelTotalToBeTrainCount}}</span>
                    </router-link>
                  </li> -->
                  <li class="nav-item" v-if="!menuConfig.knowledge.modelSetting.isHide" v-show="hasPermission('model_setting')">
                    <router-link to="/knowledge/model-setting"
                                 class="nav-link" exact>
                      Model Setting
                    </router-link>
                  </li>
                  <li class="nav-item" v-if="!menuConfig.knowledge.rulebased.isHide" v-show="hasPermission('rulebased')">
                    <router-link to="/knowledge/rule-based"
                                 class="nav-link" exact>
                      Rule-based
                    </router-link>
                  </li>
                  <li class="nav-item" v-if="!menuConfig.knowledge.nlpConfig.isHide" v-show="hasPermission('nlpconfig')">
                    <router-link to="/knowledge/nlp-config"
                                 class="nav-link" exact>
                      NLP Config
                    </router-link>
                  </li>
                  <li class="nav-item" v-if="!menuConfig.knowledge.files.isHide" v-show="hasPermission('files')">
                    <router-link to="/knowledge/files"
                                 class="nav-link" exact>
                      Files
                    </router-link>
                  </li>
                  <!-- <li class="nav-item">
                    <router-link to="/knowledge/nlp-config"
                                 class="nav-link" exact>
                      NLP Config
                    </router-link>
                  </li> -->
                  <!-- <li class="nav-item-divider" style="display:none;"></li> -->
<!--                  <li class="nav-item" v-show="hasPermission('benchmark')">-->
<!--                    <router-link to="/knowledge/benchmark"-->
<!--                                 class="nav-link" exact>-->
<!--                      Benchmark-->
<!--                    </router-link>-->
<!--                  </li>-->
                </ul>
              </li>
              <li class="nav-item" v-if="!menuConfig.oneOnOneChat.isHide" v-show="hasPermission('one_on_one_chat')">
                <router-link to="/1-on-1-chat" class="nav-link" exact>
                  <i class="fa fa-comment-dots"></i>
                  <span>1 on 1 Chats</span>
                </router-link>
              </li>
              <li class="nav-item" v-if="!menuConfig.lineBroadcast.isHide" v-show="hasPermission('line_broadcast')">
                <router-link to="/line-broadcast" class="nav-link" exact>
                  <i class="bx bx-message-square-detail" style="font-size: 18px;"></i>
                  <span>Broadcast</span>
                </router-link>
              </li>
              <li class="nav-item nav-item-submenu" v-if="!menuConfig.tools.isHide">
                <a class="nav-link no-user-select">
                  <i class="fa fa-wrench"></i>
                  <span>Tools</span>
                </a>
                <ul class="nav nav-group-sub" data-submenu-title="Tools">
                  <li class="nav-item" style="display:none;">
                    <a href="#" class="nav-link">Webform</a>
                  </li>
                  <li class="nav-item" style="display:none;">
                    <a href="#" class="nav-link">Dataset</a>
                  </li>
                  <li class="nav-item" v-if="!menuConfig.tools.valueEditor.isHide" v-show="hasPermission('value_editor')">
                    <router-link to="/tools/value-editor" class="nav-link" exact>
                      Value Editor
                    </router-link>
                  </li>
<!--                  <li class="nav-item" v-show="hasPermission('test_set_editor')">-->
<!--                    <router-link to="/tools/test-set-editor" class="nav-link" exact>-->
<!--                      Test Set Editor-->
<!--                    </router-link>-->
<!--                  </li>-->
<!--                  <li class="nav-item" v-show="hasPermission('conversation_editor')">-->
<!--                    <router-link to="/tools/conversation-editor" class="nav-link" exact>-->
<!--                      Conversation Editor-->
<!--                    </router-link>-->
<!--                  </li>-->
                  <li class="nav-item" v-if="!menuConfig.tools.exportChatLogs.isHide" v-show="hasPermission('logs_export')">
                    <router-link to="/tools/export-logs" class="nav-link" exact>
                      Export Chatlogs
                    </router-link>
                  </li>
                  <li class="nav-item" v-if="!menuConfig.tools.exportFaqReport.isHide" v-show="hasPermission('faq_report_export')">
                    <router-link to="/tools/faq-report-export" class="nav-link" exact>
                      Export FAQ Report
                    </router-link>
                  </li>
                  <li class="nav-item" v-if="!menuConfig.tools.promotions.isHide" v-show="hasPermission('promotions')">
                    <router-link to="/tools/promotions" class="nav-link" exact>
                      Promotions
                    </router-link>
                  </li>
                  <li class="nav-item" v-if="!menuConfig.tools.exportPromotionTracking.isHide" v-show="hasPermission('promotion_tracking_export')">
                    <router-link to="/tools/promotion-tracking-export" class="nav-link" exact>
                      Promotion Tracking Export
                    </router-link>
                  </li>
                </ul>
              </li>
              <li class="nav-item nav-item-submenu" v-if="!menuConfig.setting.isHide" v-show="hasPermission('user_manager')">
                <a class="nav-link no-user-select">
                  <i class="icon-gear"></i>
                  <span>Setting</span>
                </a>
                <ul class="nav nav-group-sub" data-submenu-title="Setting">
                  <li class="nav-item" style="display:none;">
                    <a href="#" class="nav-link">Bot Setting</a>
                  </li>
                  <li class="nav-item" v-if="!menuConfig.setting.userManager.isHide" v-show="hasPermission('user_manager')">
                    <router-link to="/setting/user-manager" class="nav-link" exact>
                      <span>User Manager</span>
                    </router-link>
                  </li>
                </ul>
              </li>
              <li class="nav-item" v-if="!menuConfig.activitylog.isHide">
                <router-link to="/activitylog" class="nav-link" exact>
                 <i class="fa fa-history" aria-hidden="true"></i>
                 <span>Activity Log</span>
                </router-link>
              </li>
            </ul>
          </div>
          <!-- /main navigation -->
        </div>
      </div>
      <div class="content-wrapper">
        <router-view />
        <ChangePasswordModal v-if="isActiveChangePasswordModal && userInfoData"
            :isActive="isActiveChangePasswordModal"
            :userInfoData="userInfoData"
            @closeModal="isActiveChangePasswordModal = false">
        </ChangePasswordModal>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import alice from '../alice-api';
import dashboardConfig from '../dashboard-config';
import ChangePasswordModal from '../components/Modals/ChangePasswordModal.vue';

export default {
  name: 'app',
  components: {
    ChangePasswordModal,
  },
  data() {
    // console.log(dashboardConfig.getConfig());
    return {
      menuConfig: dashboardConfig.getDefaultClientConfig(),
      isActiveChangePasswordModal: false,
      userInfoData: {},
    };
  },
  async created() {
    this.menuConfig = await dashboardConfig.getConfig();
  },
  mounted() {
    if (!this.username) {
      // Try fix manually
      // console.log('Init manually');
      const user = alice.getUser();
      if (user) {
        this.setUserData(user);
      }
    }
    this.loadUserInfo();
    this.loadModelList();
    this.loadIssuesCount();
    this.getTotalToBeTrainCount();
    try {
      setTimeout(() => {
        // eslint-disable-next-line no-undef
        App.initSidebars();
        // eslint-disable-next-line no-undef
        App.initNavigations();
      }, 1500);
    } catch (e) {
      // console.log('App global not found');
    }
  },
  methods: {
    ...mapActions({
      loadModelList: 'model/loadModelList',
      loadIssuesCount: 'issues/loadIssuesCount',
      setUserData: 'config/setUserData',
      getTotalToBeTrainCount: 'train/getTotalToBeTrainCount',
      loadUserInfo: 'config/loadUserInfo',
    }),
    logout: () => {
      alice.logout();
    },
    hasPermission(name) {
      return alice.hasPermission(this.role, name);
    },
    toggleChangePassWordModal(state) {
      this.isActiveChangePasswordModal = state;
      this.userInfoData = { ...this.userInfo };
    },
  },
  computed: {
    ...mapGetters({
      username: 'config/username',
      role: 'config/role',
      needTrainModel: 'model/needTrainModel',
      needResolveIssue: 'issues/needResolveIssue',
      issueCount: 'issues/issueCount',
      allModelTotalToBeTrainCount: 'train/allModelTotalToBeTrainCount',
      userInfo: 'config/userInfo',
    }),
  },
};
</script>
